// extracted by mini-css-extract-plugin
export var black = "#000000";
export var blue = "#0096ff";
export var brown = "#ad4f0e";
export var darkBlue = "#0673f4";
export var darkBrown = "#612c0a";
export var darkFuchsia = "#be3483";
export var darkGreen = "#2ca47e";
export var darkGrey = "#828282";
export var darkNavy = "#040052";
export var darkOlive = "#49672f";
export var darkOrange = "#dd7e03";
export var darkPink = "#dc6569";
export var darkPurple = "#864fa7";
export var darkRed = "#bf011a";
export var darkYellow = "#f3ba08";
export var fuchsia = "#e83fa1";
export var green = "#36cf9f";
export var grey = "#aaaaaa";
export var lightBackground = "#fbfcfd";
export var lightBlue = "#e7f5ff";
export var lightBlueBackground = "#f1f8fe";
export var lightBorder = "#eeeeee";
export var lightBrown = "#f8efe9";
export var lightFuchsia = "#fbdcee";
export var lightGreen = "#f6ffe8";
export var lightGrey = "#f6f6f6";
export var lightMediumGreen = "#dffddf";
export var lightMediumOrange = "#fbe8d9";
export var lightNavy = "#e8e8f3";
export var lightOlive = "#f1f5ed";
export var lightOrange = "#fff7e7";
export var lightPink = "#fff3f3";
export var lightPurple = "#f1e8ff";
export var lightRed = "#ffe5e8";
export var lightYellow = "#fffde8";
export var mediumBackground = "#f5f8fa";
export var mediumBlue = "#0096ff";
export var mediumBlueBackground = "#eaf3f9";
export var mediumBorder = "#dddddd";
export var mediumBrown = "#ad4f0e";
export var mediumFuchsia = "#e83fa1";
export var mediumGreen = "#36cf9f";
export var mediumGrey = "#aaaaaa";
export var mediumNavy = "#19369d";
export var mediumOlive = "#62933e";
export var mediumOrange = "#ffa405";
export var mediumPink = "#ff7c7c";
export var mediumPurple = "#b36be0";
export var mediumRed = "#ec1314";
export var mediumYellow = "#fece05";
export var midtoneBlue = "#afddff";
export var midtoneBrown = "#e9cfbe";
export var midtoneFuchsia = "#f6b5db";
export var midtoneGreen = "#c2f6da";
export var midtoneGrey = "#e3e3e3";
export var midtoneNavy = "#bbb9db";
export var midtoneOlive = "#d5e1ca";
export var midtoneOrange = "#ffe6bb";
export var midtonePink = "#ffdbdb";
export var midtonePurple = "#e1c9fd";
export var midtoneRed = "#ffacb6";
export var midtoneYellow = "#fff6b0";
export var navy = "#19369d";
export var olive = "#62933e";
export var orange = "#ffa405";
export var pink = "#ff7c7c";
export var purple = "#b36be0";
export var red = "#ec1314";
export var tooltip = "#626262";
export var white = "#ffffff";
export var yellow = "#fece05";